import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {useEffect, useState} from 'react';

const MESSAGE_DURATION = 2 * 1000; // 2 seconds

type RotatingLoadingMessageProps = {
  messages: string[];
  messageDuration?: number;
  size?: 'small' | 'large';
};

const RotatingLoadingMessage = ({
  messages,
  messageDuration = MESSAGE_DURATION,
  size = 'small',
}: RotatingLoadingMessageProps) => {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(
      () => setMessageIndex(state => (state + 1) % messages.length),
      messageDuration,
    );

    return () => clearInterval(intervalId);

    // We disable exhaustive deps because we only want this to run once
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Stack
      direction={size === 'small' ? 'row' : 'column'}
      sx={{
        alignItems: 'center',
        gap: 1.5,
        ...(size === 'large'
          ? {gap: 3, justifyContent: 'center', textWrap: 'pretty'}
          : {}),
      }}
    >
      <CircularProgress
        aria-label="Loading spinner"
        size={size === 'small' ? '16px' : '32px'}
      />

      <Typography variant={size === 'small' ? 'body2' : 'body1'}>
        {messages[messageIndex]}
      </Typography>
    </Stack>
  );
};

export default RotatingLoadingMessage;
